import React from 'react';
import { adaptDualBannerProps } from './DualBanner.adapter';
import './DualBanner.css';

/**
 * DualBanner 컴포넌트
 * 2개의 배너 이미지를 나란히 표시하며, 리치 에디터 콘텐츠를 오버레이로 표시
 */
const DualBanner = (props) => {
  // 속성 어댑터를 통해 props 변환
  const adaptedProps = adaptDualBannerProps(props);
  const { style = {}, data = {} } = adaptedProps;
  
  // 필요한 데이터 추출
  const {
    selectedImages = [],
    overlayColor = '#000000',
    overlayOpacity = 0.3,
    textColor = '#ffffff',
    height = 400,
    gap = 10
  } = data;
  
  // 선택된 이미지 추출
  const [leftImage, rightImage] = selectedImages;
  
  // 이미지 클릭 핸들러
  const handleImageClick = (linkUrl, linkTarget = '_self') => {
    if (linkUrl && !props.isEditor) {
      window.open(linkUrl, linkTarget);
    }
  };
  
  // 오버레이 스타일
  const overlayStyle = {
    backgroundColor: overlayColor,
    opacity: overlayOpacity
  };
  
  // 텍스트 콘텐츠 스타일
  const contentStyle = {
    color: textColor
  };
  
  // 컨테이너 스타일
  const containerStyle = {
    ...style,
    height: height,
    gap: gap
  };
  
  return (
    <div className="dual-banner-container" style={containerStyle}>
      {/* 왼쪽 배너 */}
      <div 
        className="dual-banner-item"
        onClick={() => handleImageClick(leftImage?.linkUrl, leftImage?.linkTarget)}
        style={{ cursor: leftImage?.linkUrl ? 'pointer' : 'default' }}
      >
        <img 
          src={leftImage?.imageUrl || 'https://via.placeholder.com/600x400'} 
          alt={leftImage?.altText || '배너 이미지 1'}
          className="dual-banner-image"
        />
        <div className="dual-banner-overlay" style={overlayStyle} />
        {leftImage?.textContent && (
          <div 
            className="dual-banner-content"
            style={contentStyle}
            dangerouslySetInnerHTML={{ __html: leftImage.textContent }}
          />
        )}
      </div>
      
      {/* 오른쪽 배너 */}
      <div 
        className="dual-banner-item"
        onClick={() => handleImageClick(rightImage?.linkUrl, rightImage?.linkTarget)}
        style={{ cursor: rightImage?.linkUrl ? 'pointer' : 'default' }}
      >
        <img 
          src={rightImage?.imageUrl || 'https://via.placeholder.com/600x400'} 
          alt={rightImage?.altText || '배너 이미지 2'}
          className="dual-banner-image"
        />
        <div className="dual-banner-overlay" style={overlayStyle} />
        {rightImage?.textContent && (
          <div 
            className="dual-banner-content"
            style={contentStyle}
            dangerouslySetInnerHTML={{ __html: rightImage.textContent }}
          />
        )}
      </div>
    </div>
  );
};

export default DualBanner;